export const appear = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    x: 0,
  },

  exit: { opacity: 0 },
};

export const dropdownChildVariant = {
  hidden: { opacity: 0, y: "1vh" },
  show: { opacity: 1, y: 0 },
};

export const dropIn = {
  hidden: {
    y: "0vh",
    x: "-4vw",
    //   scale: 1.2,
    opacity: 0,
  },
  visible: {
    y: "0",
    x: "0",
    //   scale: 1,
    opacity: 1,
  },
  exit: {
    x: "4vw",
    opacity: 0,
  },
};

export const commandPaletteVariants = {
  hidden: { opacity: 0, scale: 0.95 },
  show: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.1,
    },
  },

  exit: {
    opacity: 0,
    scale: 0.95,
    transition: {
      duration: 0.1,
    },
  },
};

export const dropdownVariant = {
  hidden: { opacity: 0, y: "1vh" },
  show: {
    opacity: 1,
    y: 0,
  },
  // transition: { staggerChildren: 0.5 },
  exit: { opacity: 0, y: "1vh" },
};

export const sidebarVariants = {
  hidden: { opacity: 0, x: "-1vw" },
  show: {
    opacity: 1,
    x: 0,
  },
  // transition: { staggerChildren: 0.5 },
  exit: { opacity: 0, x: "10vw" },
};

export const bossModeVariants = {
  hidden: { opacity: 0, scale: 0.95 },
  show: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.1,
    },
  },

  exit: {
    opacity: 0,
    scale: 0.95,
    transition: {
      duration: 0.1,
    },
  },
};

export const buttonVariants = {
  hidden: { scale: 0.6, opacity: 0 },
  show: {
    scale: 1,
    opacity: 1,
  },

  exit: { opacity: 0, scale: 0.8 },
};
